<template>



  <table style="width:100%">
    <tr>
      <td>
        <table style="width: 100%;">
          <tr>
            <td style="width: 20%; text-align: left; padding-top: 2%">
              <img src="/Images/kotlilogo.png" style="width:100px;height:100px" />
            </td>

</tr>
          <tr>
            <td style="text-align: center; vertical-align: middle;">
              <h4 style="margin-bottom: 0px">
                Steppingstone School
              </h4>
              <small> Al-Jalil Garden, Lahore,</small><br />
              <small>
                0334-335-336-3 (WhatsApp)

              </small><br />
              <small>
                042-3802-9999 (Landline)
              </small>
            </td>


          </tr>
          <tr>
            <td colspan="3" style="text-align: center; font-size: 10px">
              <label>
                <b>Account Title:</b>
                Steppingstone School Al Jalil Garden Campus
              </label>
              <br />
              <label>
                <b>Account No.: 0188-0110-5808-6600	</b>
              </label>
              <br />
              <label>
                Payable at all branches of APNA MICRO FINANCE BANK LTD
              </label>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <div class="card card-default shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Course</label>
                  <input class="form-control" disabled v-model="course.CourseTitle + ' - ' + course.ClassName" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mt-2">
                  <div>
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Code</th>
                          <th>Type</th>
                          <th>TotalMarks</th>
                          <th>MarksObtained</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr v-for="result in results">
                          <td>{{result.Date}}</td>
                          <td>{{result.Code}}</td>
                          <td>{{result.Type}}</td>
                          <td>{{result.TotalMarks}}</td>
                          <td>{{result.MarksObtained}}</td>
                          <td>{{result.Percentage}}</td>


                        
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </table>


</template>



<script>

  import axios from 'axios';
  export default {
    name: 'coursePrint',
    data() {
      return {
        results: [],
        course: [],
      }


    },
    created() {
      this.pageLoad();
    },
    updated() {
      $('#tbl').DataTable();
    },
    methods: {

      //show up list of data form in table from database
      pageLoad() {
        var url = new URLSearchParams(window.location.search);
        var id = url.get("teacherID")
        if (id == 0) {
          window.location.href = "/Home/Index";
        } else {
          var vm = this;
          axios.post('/api/PortalApi/pageLoadAssessmentList?teacherID=' + id)
            .then(function (res) {
              vm.course = res.data.course;
              vm.results = res.data.results;





            });

        }


      },
 

   
    }
  }

</script>
<style>
  #row-color:nth-child(odd) {
    /*background-color: #FFB6C1;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/school/print/courseResultPrint.vue